import React, {useEffect} from 'react';

export const MOBILE_APP_PATH = '/mobile';
const MOBILE_MAX_WIDTH = 767;
const REDIRECT_DELAY_MS = 150;

const isMobilePath = (pathname: string) => pathname === MOBILE_APP_PATH || pathname.startsWith(`${MOBILE_APP_PATH}/`);

const isMobileViewport = () => window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`).matches;

const redirectTo = (path: string) => {
    window.location.replace(`${window.location.origin}${path}`);
};

const applyViewportRedirect = () => {
    const mobilePath = isMobilePath(window.location.pathname);

    if (isMobileViewport() && !mobilePath) {
        redirectTo(MOBILE_APP_PATH);
        return;
    }

    if (!isMobileViewport() && mobilePath) {
        redirectTo('/');
    }
};

const MobileViewportRedirectHandler = () => {
    useEffect(() => {
        let resizeTimeout: number | undefined;

        const handleViewportChange = () => {
            window.clearTimeout(resizeTimeout);
            resizeTimeout = window.setTimeout(applyViewportRedirect, REDIRECT_DELAY_MS);
        };

        applyViewportRedirect();

        window.addEventListener('resize', handleViewportChange);
        window.addEventListener('orientationchange', handleViewportChange);

        return () => {
            window.clearTimeout(resizeTimeout);
            window.removeEventListener('resize', handleViewportChange);
            window.removeEventListener('orientationchange', handleViewportChange);
        };
    }, []);

    return null;
};

export default MobileViewportRedirectHandler;
